export default "__VITE_ASSET__5AElKoR7__"